import "./App.css"
import TopMenu from "./components/TopMenu"
import MenuList from "./components/MenuList"
import ContentEnd from "./components/ContentEnd"
function App() {
  return (
    <div className="App">
      <div className="top">
        <TopMenu />
      </div>
      <div className="contents">
        <div className="main">
          <MenuList />
        </div>
      </div>
      <ContentEnd />
    </div>
  )
}

export default App
